module.exports = __webpack_public_path__ + "static/media/set-goals-banner.3291de06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/set-goals-banner.jpg
// module id = 2226
// module chunks = 0